<!-- <ng-container *ngIf="showCropperDialog"> -->
<p-dialog [header]="'imageCropper.cropImage' | transloco" [(visible)]="showCropperDialog" [modal]="true" [style]="{ 'width': '780px' }"
  (onHide)="onCropImageDialogClose($event)">
  <div class="mt-2 px-3">
    <div class="row">
      <div class="col-9">
        <!-- There're multiple ways to open the cropper. All inputs are optional.
        Either the imageChangedEvent, imageBase64 or imageFile should be set to load an image into the cropper -->
        <!-- [imageChangedEvent]="imageChangedEvent" [imageFile]="currentSelectedFile"  -->
        <!--Note: When we use PNG format, it increases the size of output image by up to 10 times therefore I'm using JPEG-->
        <!-- [cropperMaxWidth]="1080": Using this option doesn't allow user to crop the image beyond 1080px in width -->
        @if (selectedFileBase64String) {
          <image-cropper class="image-cropper"
            [imageBase64]="selectedFileBase64String" [autoCrop]="false"
            [containWithinAspectRatio]="containWithinAspectRatio" [maintainAspectRatio]="true" [aspectRatio]="1/1"
            format="jpeg" [imageQuality]="92"
            [disabled]="false"
            [style.display]="showCropper ? null : 'none'" [onlyScaleDown]="true" [roundCropper]="false"
            [transform]="transform" [canvasRotation]="canvasRotation"
            (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()">
          </image-cropper>
        }
        <!-- <img *ngIf="croppedImage" [src]="croppedImage" /> -->
      </div>
      <div class="col-3 g-0 crop-options">
        <p-panel styleClass="h-100" [header]="'imageCropper.cropOptions' | transloco">
          <div class="d-flex flex-column justify-content-between h-100">
            <div class="flex-grow-1">
              <div class="form-group mt-2">
                <label for="rotationAngle">{{ 'imageCropper.rotationAngle' | transloco }}</label>
                <input pInputText type="number" [(ngModel)]="rotation" class="form-control" [placeholder]="'imageCropper.rotationAngle' | transloco" (keyup)="updateRotation()" id="rotationAngle" name="rotationAngle" />
              </div>
              <button pButton type="button" class="p-button-outlined w-100 mt-2" icon="fa fa-undo" [label]="'imageCropper.rotateLeft' | transloco" (click)="rotateLeft()"></button>
              <button pButton type="button" class="p-button-outlined w-100 mt-1" icon="fa fa-repeat" [label]="'imageCropper.rotateRight' | transloco" (click)="rotateRight()"></button>

              <!-- <div><button type="button" class="btn btn-primary w-100 mb-1" (click)="flipHorizontal()">Flip Horizontal</button></div>
              <div><button type="button" class="btn btn-primary w-100 mb-1" (click)="flipVertical()">Flip Vertical</button></div> -->
              <!-- <div>
              <button type="button" class="btn btn-primary w-100 mb-1" (click)="toggleContainWithinAspectRatio()">
                <ng-container *ngIf="containWithinAspectRatio">Fill within Aspect Ratio</ng-container>
                <ng-container *ngIf="!containWithinAspectRatio">Contain within Aspect Ratio</ng-container>
              </button>
            </div> -->
            <div class="mt-4">
              <button pButton type="button" class="p-button-outlined w-100" icon="fa fa-search-plus" [label]="'imageCropper.zoomIn' | transloco" (click)="zoomIn()"></button>
              <button pButton type="button" class="p-button-outlined w-100 mt-1" icon="fa fa-search-minus" [label]="'imageCropper.zoomOut' | transloco" (click)="zoomOut()"></button>
            </div>
            <button pButton type="button" class="p-button-outlined w-100 mt-2" icon="fa fa-eraser" [label]="'imageCropper.resetImage' | transloco" (click)="resetImage()"></button>
          </div>
          <div class="mt-2">
            <button pButton type="button" class="p-button-outlined p-button-danger w-100" icon="fa fa-crop" [label]="'imageCropper.cropAndSave' | transloco" (click)="cropImage($event)"></button>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>
</p-dialog>
<!-- </ng-container> -->